import React from 'react'
import { BoxProps } from '@chakra-ui/core'

import { Box } from '../Box'

export interface TextProps extends BoxProps {}

export const Text = (props: TextProps) => {
  return <Box as="p" fontFamily="body" {...props} />
}

export default Text
